// client/src/pages/HowItWorks.tsx - WITH TIER SYSTEM EXPLANATION
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HowItWorks() {
    const [videoUrl, setVideoUrl] = useState('https://www.youtube.com/embed/zd7tYWdtC7U');

    return (
        <div className="min-h-screen bg-gray-50 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        How Expert Link Pro Works
                    </h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Watch our comprehensive walkthrough to learn how to effectively use our platform
                    </p>
                </div>

                {/* Video Section */}
                <div className="bg-white rounded-lg shadow-xl p-8 mb-12">
                    {videoUrl ? (
                        <div className="aspect-w-16 aspect-h-9">
                            <iframe
                                src={videoUrl}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="w-full h-full rounded-lg"
                                style={{ minHeight: '500px' }}
                            ></iframe>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center h-96 bg-gray-100 rounded-lg">
                            <div className="text-center">
                                <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                                <p className="mt-2 text-gray-500">Video walkthrough coming soon</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Step-by-Step Guide */}
                <div className="grid md:grid-cols-2 gap-12 mb-12">
                    <div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">For Attorneys</h2>
                        <div className="space-y-6">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
                                    1
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Sign Up & Complete Profile</h3>
                                    <p className="text-gray-600 mt-1">
                                        Create your account and provide your firm details and practice areas.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
                                    2
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Subscribe to Access Experts</h3>
                                    <p className="text-gray-600 mt-1">
                                        Choose a monthly plan and get started with searches today.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
                                    3
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Search for Experts</h3>
                                    <p className="text-gray-600 mt-1">
                                        Use our advanced filters to find experts by specialty, location, experience, and more.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
                                    4
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Contact & Collaborate</h3>
                                    <p className="text-gray-600 mt-1">
                                        Send messages to experts and manage your case communications securely.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">For Medical Experts</h2>
                        <div className="space-y-6">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">
                                    1
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Register as Expert</h3>
                                    <p className="text-gray-600 mt-1">
                                        Sign up and complete your professional profile with credentials and experience.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">
                                    2
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Get Verified</h3>
                                    <p className="text-gray-600 mt-1">
                                        Our team reviews your credentials within 2-3 business days.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">
                                    3
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Receive Inquiries</h3>
                                    <p className="text-gray-600 mt-1">
                                        Get notified when attorneys contact you about potential cases.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">
                                    4
                                </div>
                                <div className="ml-4">
                                    <h3 className="font-semibold text-gray-900">Manage Engagements</h3>
                                    <p className="text-gray-600 mt-1">
                                        Respond to inquiries and manage your expert witness engagements.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Expert Tier System Explanation */}
                <div className="bg-white rounded-lg shadow-xl p-8 mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">Understanding Expert Tiers</h2>
                    <p className="text-gray-600 text-center mb-8">
                        Our comprehensive vetting system categorizes experts into five quality tiers
                    </p>

                    <div className="space-y-6">
                        <div className="flex items-start p-6 bg-yellow-50 rounded-lg border-l-4 border-yellow-500">
                            <div className="flex-shrink-0 w-12 h-12 bg-yellow-500 text-white rounded-full flex items-center justify-center font-bold mr-4">5</div>
                            <div>
                                <h3 className="font-bold text-gray-900 mb-2">Elite</h3>
                                <p className="text-gray-700">No challenges to date or has survived challenges across jurisdictions. Stellar ELP vetting, excellent attorney reviews, exemplary communication. Prestige signals present (Ivy League education, academic medical-center affiliation, peer-reviewed publications).</p>
                            </div>
                        </div>

                        <div className="flex items-start p-6 bg-purple-50 rounded-lg border-l-4 border-purple-500">
                            <div className="flex-shrink-0 w-12 h-12 bg-purple-500 text-white rounded-full flex items-center justify-center font-bold mr-4">4</div>
                            <div>
                                <h3 className="font-bold text-gray-900 mb-2">Verified Pro</h3>
                                <p className="text-gray-700">No challenges or has survived challenges. Deposition or trial experience, excellent attorney reviews, strong report quality. Clear, lay-friendly explanations. Evidence of teaching or speaking engagements.</p>
                            </div>
                        </div>

                        <div className="flex items-start p-6 bg-blue-50 rounded-lg border-l-4 border-blue-500">
                            <div className="flex-shrink-0 w-12 h-12 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold mr-4">3</div>
                            <div>
                                <h3 className="font-bold text-gray-900 mb-2">Verified Experienced</h3>
                                <p className="text-gray-700">Consistent case work with ELP vetting. Dependable delivery and communication, solid reviews. Building courtroom record and strengthening admissibility training/readiness.</p>
                            </div>
                        </div>

                        <div className="flex items-start p-6 bg-green-50 rounded-lg border-l-4 border-green-500">
                            <div className="flex-shrink-0 w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold mr-4">2</div>
                            <div>
                                <h3 className="font-bold text-gray-900 mb-2">Verified Emerging</h3>
                                <p className="text-gray-700">Meets all verification gatekeepers. Board certification obtained where applicable. Early litigation activity, basic rate transparency, minimum attorney review or referral.</p>
                            </div>
                        </div>

                        <div className="flex items-start p-6 bg-gray-50 rounded-lg border-l-4 border-gray-500">
                            <div className="flex-shrink-0 w-12 h-12 bg-gray-500 text-white rounded-full flex items-center justify-center font-bold mr-4">1</div>
                            <div>
                                <h3 className="font-bold text-gray-900 mb-2">Listed</h3>
                                <p className="text-gray-700">Identity and credentials verified. No disqualifying sanctions. Conflict-check workflow in place. Limited or no litigation history, building review profile.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="bg-blue-50 rounded-lg p-8 text-center">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        Ready to Get Started?
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Join our platform today and connect with verified medical experts
                    </p>
                    <div className="flex justify-center space-x-4">
                        <Link
                            to="/signup"
                            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            Sign Up Now
                        </Link>
                        <Link
                            to="/login"
                            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                        >
                            Log In
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}